import { render, staticRenderFns } from "./ClientMainSearch.vue?vue&type=template&id=84c40b40&scoped=true&"
import script from "./ClientMainSearch.vue?vue&type=script&lang=js&"
export * from "./ClientMainSearch.vue?vue&type=script&lang=js&"
import style0 from "./ClientMainSearch.vue?vue&type=style&index=0&id=84c40b40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c40b40",
  null
  
)

export default component.exports